import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import SignatureCanvasImpl from "../../signature-canvas/signatureCanvasImpl";

export default function ModalSignature({ setShowModalSignature }: any) {
  const [visible, setVisible] = useState(true);
  const [position, setPosition] = useState<
    | "center"
    | "right"
    | "top"
    | "bottom"
    | "left"
    | "top-left"
    | "top-right"
    | "bottom-left"
    | "bottom-right"
  >("center");
  const footerContent = (
    <div>
      {/*<Button
        id="btnNoModalSignature"
        label="Cancelar"
        icon="pi pi-times"
        onClick={() => setShowModalSignature(false)}
        className="p-button-text base-button-noback"
      />
      <Button
        id="btnYesModalSignature"
        label="Envíar"
        icon="pi pi-check"
        onClick={() => setShowModalSignature(false)}
        autoFocus
        className="base-button"
      />*/}
    </div>
  );

  const show = (position: any) => {
    setPosition(position);
    setShowModalSignature(true);
  };

  useEffect(() => {
    show("right");
  }, []);

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Dialog
        header="Registro de firma digital"
        visible={visible}
        position={position}
        style={{ width: "100%", height: "100%" }}
        onHide={() => {
          if (!visible) return;
          setShowModalSignature(false);
        }}
        footer={footerContent}
        draggable={false}
        resizable={false}
      >
        <SignatureCanvasImpl setShowModalSignature={setShowModalSignature} />
      </Dialog>
    </div>
  );
}
